import History from 'modules/history'

const HistoryPage = () => {
	return <History />
}

export default HistoryPage
